import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoMedio3FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. DOC' htmlFor='input-numeroDocumentoMedio3' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='numeroDocumentoMedio3'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-numeroDocumentoMedio3' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoMedio3FormGroup)
